import './SitiAmici.css';

interface SitoAmico {
    url: string;
    titolo: string;
    sottotitolo?: string;
    descrizione: string;
    logo?: string;
}

const sitiAmici: SitoAmico[] = [
    {
        url: 'https://nicastro.in/',
        titolo: 'Facondia Lab',
        sottotitolo: "Un'iniziativa di nicastro.in",
        descrizione: "Facondia Lab è l'iniziativa con cui nicastro.in costruisce app Android per digitalizzare piccoli ambiti della vita quotidiana.",
        logo: process.env.PUBLIC_URL + '/siti-amici/facondia-lab-logo.jpeg',
    },
];

function SitiAmici() {
    return (
        <div className='siti-amici-container'>
            <h1 className='siti-amici-title'>Siti Amici</h1>

            {sitiAmici.length > 0 ? (
                <div className='siti-amici-grid'>
                    {sitiAmici.map((sito) => (
                        <a
                            key={sito.url}
                            className='sito-amico-card'
                            href={sito.url}
                            target='_blank'
                            rel='noreferrer'
                        >
                            {sito.logo && (
                                <div className='sito-amico-logo'>
                                    <img src={sito.logo} alt="" />
                                </div>
                            )}
                            <div className='sito-amico-body'>
                                <h2 className='sito-amico-titolo'>{sito.titolo}</h2>
                                {sito.sottotitolo && (
                                    <h3 className='sito-amico-sottotitolo'>{sito.sottotitolo}</h3>
                                )}
                                <p className='sito-amico-descrizione'>{sito.descrizione}</p>
                            </div>
                        </a>
                    ))}
                </div>
            ) : null}
        </div>
    );
}

export default SitiAmici;
